import { OverlayTrigger, Pagination, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  page: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
};

/** カード一覧のページ送り（総件数が pageSize 以下なら非表示） */
export default function TppCardListPagination({ page, total, pageSize, onPageChange }: Props) {
  const { t } = useTranslation();
  if (total <= pageSize) return null;
  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 mb-4">
      <Pagination size="sm" className="mb-0">
        <Pagination.Prev
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          aria-label={t('common.previous')}
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tpp-cards-page-prev">{t('tpp.tooltip_page_prev')}</Tooltip>}
          >
            <span className="d-inline-block">
              <i className="fas fa-chevron-left" aria-hidden />
            </span>
          </OverlayTrigger>
        </Pagination.Prev>
        <Pagination.Item active>
          {page} / {totalPages}
        </Pagination.Item>
        <Pagination.Next
          disabled={page >= totalPages}
          onClick={() => onPageChange(page < totalPages ? page + 1 : page)}
          aria-label={t('common.next')}
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tpp-cards-page-next">{t('tpp.tooltip_page_next')}</Tooltip>}
          >
            <span className="d-inline-block">
              <i className="fas fa-chevron-right" aria-hidden />
            </span>
          </OverlayTrigger>
        </Pagination.Next>
      </Pagination>
      <span className="small text-muted">
        {t('tpp.total_cards')} {total}{' '}
        {t('tpp.cards_unit')}
      </span>
    </div>
  );
}
